import { jwtDecode, JwtPayload } from 'jwt-decode'

import { environmentVariables } from '../utils/environmentVariables'

type SwileJwt = JwtPayload & {
  sudoer_uid?: string
  sudoer_email?: string
}

const COOKIES = {
  ACCESS_TOKEN: 'lunchr:jwt',
  REFRESH_TOKEN: 'lunchr:rt',
  // sudo cookie is currently used in some client apps to customize the display
  IS_SUDO: 'lunchr:sudo',
}

const THREE_DAYS = 3 * 24 * 60 * 60
const EXPIRED = 0

const cookieOptions = (ttl: number): string => {
  const options = [
    `max-age=${ttl}`,
    'path=/',
    `domain=${environmentVariables('JWT_COOKIES_DOMAIN')}`,
    'samesite=lax',
    environmentVariables('JWT_COOKIES_SECURE') === 'true' ? 'secure' : '',
  ]
  return options.join(';')
}

const getCookie = (name: string): string | undefined => `; ${document.cookie}`.split(`; ${name}=`).pop()?.split(';')[0]

const setCookie = (name: string, value: string): string =>
  (document.cookie = `${name}=${value};${cookieOptions(THREE_DAYS)}`)

const removeCookie = (name: string): string => (document.cookie = `${name}=;${cookieOptions(EXPIRED)}`)

export const saveTokens = (accessToken: string, refreshToken: string | null): void => {
  setCookie(COOKIES.ACCESS_TOKEN, accessToken)
  if (refreshToken) {
    setCookie(COOKIES.REFRESH_TOKEN, refreshToken)
  } else {
    removeCookie(COOKIES.REFRESH_TOKEN)
  }

  const jwt = jwtDecode<SwileJwt>(accessToken)

  if (jwt.sudoer_uid || jwt.sudoer_email) {
    setCookie(COOKIES.IS_SUDO, 'true')
  } else {
    removeCookie(COOKIES.IS_SUDO)
  }
}

export const clearSavedTokens = (): void => {
  removeCookie(COOKIES.ACCESS_TOKEN)
  removeCookie(COOKIES.REFRESH_TOKEN)
  removeCookie(COOKIES.IS_SUDO)
}

export const getRefreshToken = (): string | undefined => {
  return getCookie(COOKIES.REFRESH_TOKEN)
}
